import { Component } from '@angular/core';
import { ProductsComponent } from './products.component';

@Component({
  selector: 'eid-products-mobile',
  templateUrl: './products.mobile.component.html',
  styleUrls: ['./products.mobile.component.scss']
})
export class ProductsMobileComponent extends ProductsComponent {}
